import { render } from "./LinkVenta.vue?vue&type=template&id=2d0145b5"
import script from "./LinkVenta.vue?vue&type=script&lang=js"
export * from "./LinkVenta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__